export const handleAccessibility = $this => {
  // START GENAI@CHATGPT4
  const allSlides = Array.from($this.el.querySelectorAll('.slide'));
  // START GENAI@GHCOPILOT
  if (allSlides.length > 0) {
    // END GENAI@GHCOPILOT
    const activeEl = $this.el.querySelector('.active');
    const activeElIndex = allSlides.indexOf(activeEl);
    // END GENAI@CHATGPT4
    const liBeforeCurrent = [...allSlides].slice(0, activeElIndex);
    const liAfterCurrent = [...allSlides].slice(activeElIndex + 1, allSlides.length);
    makeLiUnaccessible(liBeforeCurrent);
    makeLiUnaccessible(liAfterCurrent);
    setAccessibleItemsVisibility(activeEl, true);
  }
};

// START GENAI@CHATGPT4
export let setAccessibleItemsVisibility = (listItem: any, shouldShow: boolean) => {
  let allAnchors = [...listItem.getElementsByTagName('a')];
  let allButtons = [...listItem.getElementsByTagName('button')];

  let tabIndexValue = shouldShow ? '0' : '-1';

  allAnchors.forEach(anc => {
    anc.setAttribute('tabindex', tabIndexValue);
  });

  allButtons.forEach(btn => {
    btn.setAttribute('tabindex', tabIndexValue);
  });
};
// END GENAI@CHATGPT4

export let makeLiUnaccessible = (list: any) => {
  list.forEach(liElement => {
    setAccessibleItemsVisibility(liElement, false);
  });
};
